/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrefilledEmailResponseDTO
 */
export interface CreatePrefilledEmailResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof CreatePrefilledEmailResponseDTO
     */
    id: number;
}

export function CreatePrefilledEmailResponseDTOFromJSON(json: any): CreatePrefilledEmailResponseDTO {
    return CreatePrefilledEmailResponseDTOFromJSONTyped(json, false);
}

export function CreatePrefilledEmailResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrefilledEmailResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreatePrefilledEmailResponseDTOToJSON(value?: CreatePrefilledEmailResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

